var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("AppHeader", {
        attrs: { userName: "userName", userRole: _vm.userRole }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-body" },
        [
          _c("Sidebar"),
          _vm._v(" "),
          _c("main", { staticClass: "main" }, [
            _c(
              "div",
              { staticClass: "container-fluid" },
              [_c("router-view")],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("AppFooter"),
      _vm._v(" "),
      _c("EventModal"),
      _vm._v(" "),
      _c("FaqModal"),
      _vm._v(" "),
      _c("AddonsModal"),
      _vm._v(" "),
      _c("HistoryModal"),
      _vm._v(" "),
      _c("ModalChangeOrderDetail"),
      _vm._v(" "),
      _c("ModalInfo"),
      _vm._v(" "),
      _c("ModalEditEventDetail")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8174f406", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8174f406","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 1590
// module chunks = 1